import { createFileRoute, notFound } from "@tanstack/react-router";

import { ThemePage } from "../components/lidoo/theme-page";
import { clubsByTheme } from "../lib/api/lidoo.functions";
import { DICTS, fill } from "../lib/i18n";
import { catalogueHreflang } from "../lib/seo";
import { themeFromSlug } from "../lib/themes";

export const Route = createFileRoute("/theme/$theme/")({
  loader: async ({ params }) => {
    const theme = themeFromSlug(params.theme);
    if (!theme) throw notFound();
    const res = await clubsByTheme({ data: { theme } });
    return { ...res, theme };
  },
  head: (ctx) => {
    const d = DICTS["en"];
    const theme = ctx.loaderData?.theme;
    if (!theme) return {};
    const what = d[`th_${theme}`] ?? "";
    return {
      meta: [
        { title: `${what} | sunbedly` },
        {
          name: "description",
          content: fill(d.th_meta_all, {
            what,
            n: String(ctx.loaderData?.clubs.length ?? 0),
            r: String(ctx.loaderData?.regions.length ?? 0),
          }),
        },
      ],
      links: catalogueHreflang(`/theme/${ctx.params.theme}`),
    };
  },
  component: ThemeIndexPage,
});

function ThemeIndexPage() {
  const { theme, clubs, regions } = Route.useLoaderData();
  return <ThemePage theme={theme} clubs={clubs} regions={regions} />;
}
